import { Injectable } from "@angular/core";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { BehaviorSubject } from "rxjs";
import { AppConfig } from "../app-config.loader";

@Injectable({
  providedIn: "root",
})
export class SignalrService {
  private readonly hubConnection: HubConnection;
  private readonly messageSource = new BehaviorSubject<any>("");
  currentMessage$ = this.messageSource.asObservable();

  constructor(appConfig: AppConfig) {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(appConfig.settings.signalrHubUrl)
      .build();
  }

  public startConnection = () => {
    this.hubConnection
      .start()
      .then(() => {})
      .catch(() => {});
  };

  public updateAllegatiListListener = () => {
    this.hubConnection.on("UpdateAllegatiList", (documentoId) => {
      this.messageSource.next(documentoId);
    });
  };
}
